import _ from 'underscore';
import $ from 'jquery';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import onClickOutside from 'react-onclickoutside';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import {
  FormGroup,
  Label,
} from '@bingads-webui-react/primitive';
import { HelpPopup } from '@bingads-webui-react/help-popup';
import {
  sharedProps as hocProps,
  sharedDefaults as hocDefaults,
  providesProps,
  providesDefaults,
  expressionTokenTypes,
} from '@bingads-webui-react/hoc-with-expression-editor-controls';

import { ControlsToolbar } from './component/controls-toolbar';
import { Expression } from './component/expression';
import { SegmentSelector } from './component/segment-selector';
import { fixSVGClassListSupportForIE } from './shim';
import { editorStyle } from './style';

const editorId = 'custom-column-expression-editor';

class ExpressionEditor extends React.PureComponent {
  static autoCompleteDropDownClassName = 'custom-column-auto-complete-dropdown';
  static toolbarMetricDropDownClassName = 'custom-column-metric-picker';
  static toolbarCategoryDropDownClassName = 'custom-column-metric-category';

  state = {
    hideValidationError: true,
  }

  componentDidMount() {
    fixSVGClassListSupportForIE();
  }

  componentDidUpdate() {
    const { hideValidationError } = this.state;
    const { expressionTokens } = this.props;

    if (hideValidationError &&
      (expressionTokens.length > 1 ||
      (expressionTokens.length === 1 && expressionTokens[0].type === expressionTokenTypes.TEXT && expressionTokens[0].value !== ''))
    ) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ hideValidationError: false });
    }
  }

  // for react-onclickoutside
  handleClickOutside = (event) => {
    if (this.props.currentFocus !== -1 &&
      $(event.target).parents(`.${ExpressionEditor.autoCompleteDropDownClassName}`).length === 0 &&
      $(event.target).parents(`.${ExpressionEditor.toolbarMetricDropDownClassName}`).length === 0 &&
      $(event.target).parents(`.${ExpressionEditor.toolbarCategoryDropDownClassName}`).length === 0
    ) {
      this.props.setFocus(-1);
    }
  };

  render() {
    const {
      className,
      containerRef,
      currentFocus,
      mostRecentMetricFocus,
      doWithClosest,
      expressionTokens,
      i18n,
      metricCategories,
      onDropdownValueSelectedFactory,
      onFocusFactory,
      onInputChangeFactory,
      onInputClickFactory,
      onInputKeyUpFactory,
      onMetricKeyUpFactory,
      onMetricRemoveButtonClickFactory,
      onMetricSelected,
      onOperatorSelected,
      onSegmentChangedFactory,
      segmentCategories,
      setChildRefByIndex,
      setChildRefCount,
      setFocus,
      zIndexStart,
      isValid,
      isExpressionTooLong,
      classes,
    } = this.props;

    setChildRefCount(expressionTokens.length);

    const lastSelectedToken = mostRecentMetricFocus >= 0 ?
      expressionTokens[mostRecentMetricFocus] : null;
    const lastSelectedColumn =
      lastSelectedToken && lastSelectedToken.type === expressionTokenTypes.COLUMN
        ? lastSelectedToken
        : null;
    const formulaLabelId = 'custom-column-formula';

    return (
      <FormGroup className={classNames(className, classes.customColumnEditor)}>
        <Label id={formulaLabelId}>{i18n.getString('CustomColumn_ColumnFormulaLabel')}
          <HelpPopup
            aria-label={i18n.getString('CustomColumn_FormulaHelpLabel')}
            topic="pop_BA_Campaign_CustomCol_Formula"
          />
        </Label>
        <div className="custom-column-editor-area">
          <div
            aria-labelledby={formulaLabelId}
            className={classNames('ms-Fabric--isFocusVisible', 'editor-container', isValid || this.state.hideValidationError ? '' : 'error')}
          >
            <ControlsToolbar
              i18n={i18n}
              metricCategories={metricCategories}
              onMetricSelected={onMetricSelected}
              onOperatorSelected={onOperatorSelected}
              metricDropDownClassName={ExpressionEditor.toolbarMetricDropDownClassName}
              metricCategoryDropDownClassName={ExpressionEditor.toolbarCategoryDropDownClassName}
              zIndexStart={zIndexStart + 30}
            />
            <Expression
              currentFocus={currentFocus}
              mostRecentMetricFocus={mostRecentMetricFocus}
              autoCompleteDropDownClassName={ExpressionEditor.autoCompleteDropDownClassName}
              expressionTokens={expressionTokens}
              i18n={i18n}
              id={editorId}
              metricCategories={metricCategories}
              onClick={doWithClosest(({ index, ref }) => {
                  setFocus(index, $(ref).find('input')[0]);
                 })}
              onDropdownValueSelectedFactory={onDropdownValueSelectedFactory}
              onFocusFactory={onFocusFactory}
              onInputChangeFactory={onInputChangeFactory}
              onInputClickFactory={onInputClickFactory}
              onInputKeyUpFactory={onInputKeyUpFactory}
              onMetricKeyUpFactory={onMetricKeyUpFactory}
              onMetricRemoveButtonClickFactory={onMetricRemoveButtonClickFactory}
              setRefFactory={setChildRefByIndex}
              containerRef={containerRef}
              zIndexStart={zIndexStart + 20}
            />
          </div>
          <SegmentSelector
            categories={segmentCategories}
            i18n={i18n}
            onSegmentChangedFactory={onSegmentChangedFactory}
            selectedToken={lastSelectedColumn}
          />
        </div>
        {isExpressionTooLong ?
        (
          <div role="alert">
            <div className="error">{i18n.getString('CustomColumnExpressionEditor_Expression_Too_Long')}</div>
          </div>
         ) : null}
      </FormGroup>
    );
  }
}

ExpressionEditor.propTypes = PropTypes.shape(_.defaults({
  className: PropTypes.string,
  i18n: PropTypes.shape({ getString: PropTypes.func.isRequired }).isRequired,
  zIndexStart: PropTypes.number,
}, hocProps, providesProps)).isRequired;

ExpressionEditor.defaultProps = _.defaults({
  className: editorId,
  zIndexStart: 1000,
}, hocDefaults, providesDefaults);

export const CustomColumnExpressionEditor =
  withDefaultStyles(onClickOutside(ExpressionEditor), editorStyle);
